<template>
  <div>
    <AllCases :selectedFaxFlag="faxFlag"></AllCases>
  </div>
</template>

<script>
const AllCases = defineAsyncComponent(() =>
  import("@/components/cases/AllCases")
);
import { defineAsyncComponent } from "vue";
export default {
  components: {
    AllCases,
  },
  data() {
    return {
      faxFlag: "NOT_SENT",
    };
  },
};
</script>
